import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const bull = (
  <Box
    component="span"
    sx={{display: 'inline-block', mx: '2px', transform: 'scale(0.8)'}}
  >
    •
  </Box>
);

export default function Advertisement() {
  return (
    <Card sx={{minWidth: 275, mt: 2, mb: 2, border: '3px solid blue', backgroundColor: 'lightgrey'}}
          variant={'outlined'}>
      <CardContent>
        <Typography sx={{fontSize: 14}} color="text.secondary" gutterBottom>
          Advertisement
        </Typography>
        <Typography variant="h5" component="div">
          Ad{bull}ver{bull}tise{bull}ment
        </Typography>
        <Typography sx={{mb: 1.5}} color="text.secondary">
          Advertisement
        </Typography>
        <Typography variant="body2">
          Advertisement
          <br/>
          {'"Advertisement"'}
        </Typography>
      </CardContent>
      <CardActions>
        <Button size="small">Learn More</Button>
      </CardActions>
    </Card>
  );
}
